export default __webpack_public_path__ + "static/media/dashboardLogout.cdb005b1.svg";